export const environment = {
  production: true,
  buildId: '2532297805717511',
  configFile: 'config.json',
};
